var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheveronDownSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2322_3068",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    width: 18,
    height: 18,
    transform: "rotate(90 18 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2322_3068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75962 7.05013L5.54999 6.25977L8.99999 9.70977L12.45 6.25977L13.2404 7.05013L8.99999 11.2905L4.75962 7.05013Z",
    fill: "#5E5E5E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheveronDownSmall);
export default __webpack_public_path__ + "static/media/cheveron_down_small.7dd958bf0a5e24508715a0fc2ce3c855.svg";
export { ForwardRef as ReactComponent };